/* External */
import { call, all, select, race, take } from "redux-saga/effects";
import { delay } from "redux-saga";

/* Actions */
import { baseActionName } from "./actions";
import { actionTypes as allStationsActionTypes } from "../allStations/actions";

/* Services */
import { backendService } from "../../services";

/* Other */
import { makeFetchSaga, BLIM_SEARCH_SOURCE, UNFINISHED_STATUS_TYPES } from "../../utils";
const SEARCH_ANIMATION_TIME = 1000;

export function* populateWithStationName(asset = {}) {
  const populatedAsset = { ...asset };

  if (!!asset.stationID && !asset.stationName) {
    const { data = [], status: allStationsStatus } = yield select(({ allStations = {} }) => allStations);
    let allStationsData = data;

    if (UNFINISHED_STATUS_TYPES.some((status) => status === allStationsStatus)) {
      yield race({
        allStationsSuccess: take(allStationsActionTypes.SUCCESS),
        allStationsFailure: take(allStationsActionTypes.FAILURE)
      });

      const { data = [] } = yield select(({ allStations = {} }) => allStations);
      allStationsData = data;
    }

    const stateStation = allStationsData.find(({ id }) => id === asset.stationID);

    if (stateStation && stateStation.id) {
      populatedAsset.stationName = stateStation.name;
    }
  }

  return populatedAsset;
}

function* searchResults(query) {
  //This delay is added to ensure the blur animation from search is played in its entirety
  yield delay(SEARCH_ANIMATION_TIME);
  const { data: { results = [] } = {} } = yield call(backendService.content.searchContentRecommendations, { query });
  const filteredResults = results.filter(({ source = 1 }) => source !== BLIM_SEARCH_SOURCE);
  let populatedResults = [],
    populatedResult = {};
  for (const result of filteredResults) {
    populatedResult = yield populateWithStationName(result);
    populatedResults.push(populatedResult);
  }
  return { data: populatedResults };
}

const searchResultsSaga = makeFetchSaga(baseActionName, {
  func: searchResults,
  getParams: (query) => [query]
});

export default function* search() {
  yield all([searchResultsSaga]);
}
